import AttachmentItem from "components/Attachments/AttachmentItem";
import CopyAttachmentButton from "components/Attachments/CopyAttachmentButton";
import { getFileIcon, getOriginalFileName } from "utils/utils";

const renderFileChip = (url) => (
  <span className="flex items-center gap-1">
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 bg-app-surface-muted hover:bg-app-surface-hover rounded-lg px-3 py-2 transition-colors"
    >
      {getFileIcon(url)}
      <span className="text-sm text-app-text">{getOriginalFileName(url)}</span>
    </a>
    <CopyAttachmentButton url={url} />
  </span>
);

/**
 * An attachment in a note thread: images preview inline and open large on click, other files are
 * a name link that opens in a new tab. Either way it can be copied.
 */
const AttachmentChip = ({ url }) => <AttachmentItem url={url} renderFile={renderFileChip} />;

export default AttachmentChip;
